module.exports = __webpack_public_path__ + "img/tiendita-bg.1cfaf564.jpg";